import {GetterTree} from "vuex";
import {FormModalState} from "@service/store/types/FormModalState";
import {RootState} from "@service/store/types/RootState";
import {FormModalElement} from "@service/types/FormModalElement";
import router from "../../router";

const getters: GetterTree<FormModalState, RootState> = {
    liveAmount: state => {
        return state.elements.filter(item => {
            return item.isLive
        }).length;
    },
    programElements: state => {
        return state.elements.filter(item => ['session', 'meeting'].indexOf(item.type) >= 0) || [];
    },
    catalogElements: state => {
        return state.elements.filter(item => ['partner'].indexOf(item.type) >= 0) || [];
    },
    openedMeeting: state => {
        return state.elements.find((item: FormModalElement) => {
            return item.type == 'meeting' && item.id == router.currentRoute.params.id;
        });
    },
    openedSession: state => {
        return state.elements.find((item: FormModalElement) => {
            return item.type == 'session'  && item.id == router.currentRoute.params.id;
        });
    },
    openElementById: state => (id: string) => {
        return state.elements.find((item: FormModalElement) => {
            return item.id == id;
        });
    },
    hasElement: state => (id: string, type: string) => {
        return state.elements.findIndex(item => item.id == id && item.type == type) >= 0;
    }
};

export {getters}